import { Dialog, DialogContent } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';

import { getNewToday, getOverDue, getPendingThisWeek, getPendingToday,getPendingTomorrow, getTotal } from '../pendingReportServices';
import GrievanceListDialog from './GrievanceListDialog';

function SupervisorPendingCounter({reportData,assignedGrievanceType,masters,getMasterLabel}) {

    const [dialogStatus, setDialogStatus] = useState(false);
    const [pendingData,setPendingData] = useState(null);

    const handleCountClick = ( func, type) =>{
        let data = func(reportData,type);
        setPendingData(data);
        setDialogStatus(true);
    }

    return (
        <>
            
                    <div className='row mb-3'>
                        <div className="col-md-2 ">
                            <div className="card bg-success text-white shadow p-1">
                                <div>New Today</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(getNewToday)}>
                                        {getNewToday(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-warning shadow p-1">
                                <div>Pending Today</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(getPendingToday)}>
                                        {getPendingToday(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-info shadow p-1">
                                <div>Pending Tomorrow</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(getPendingTomorrow)}>
                                        {getPendingTomorrow(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-primary text-white shadow p-1">
                                <div>Pending This Week</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(getPendingThisWeek)}>
                                        {getPendingThisWeek(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-danger text-white shadow p-1">
                                <div>Over Due</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(getOverDue)}>
                                        {getOverDue(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>
                        <div className="col-md-2 ">
                            <div className="card bg-dark text-white shadow p-1">
                                <div>Total</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(getTotal)}>
                                        {getTotal(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>                            
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Grievance Type</th>
                                        <th className='bg-success text-white'>New Today</th>
                                        <th className='bg-warning'>Pending Today</th>
                                        <th className='bg-info'>Pending Tomorrow</th>
                                        <th className='bg-primary text-white'>Pending This Week</th>
                                        <th className='bg-danger text-white'>Overdue</th>
                                        <th className='bg-dark text-white'>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {assignedGrievanceType.map(grievanceType=>
                                        <tr>
                                            <th>{getMasterLabel('grievance-type',  grievanceType)}</th>
                                            <td className='bg-success text-white'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(getNewToday,grievanceType)}>
                                                    {getNewToday(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                            <td className='bg-warning'>
                                                <button className='btn btn-link' type='button' onClick={()=>handleCountClick(getPendingToday,grievanceType)}>
                                                    {getPendingToday(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                                
                                            <td className='bg-info'>
                                                <button className='btn btn-link' type='button' onClick={()=>handleCountClick(getPendingTomorrow,grievanceType)}>
                                                    {getPendingTomorrow(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                            <td className='bg-primary text-white'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(getPendingThisWeek,grievanceType)}>
                                                    {getPendingThisWeek(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                            <td className='bg-danger text-white'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(getOverDue,grievanceType)}>
                                                    {getOverDue(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                            <td className='bg-dark text-white'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(getTotal,grievanceType)}>
                                                    {getTotal(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                
                    <GrievanceListDialog grievanceList={pendingData} dialogStatus={dialogStatus} setDialogStatus={setDialogStatus} getMasterLabel={getMasterLabel} />
        </>
    )
}

export default SupervisorPendingCounter




{/*
                    <div className='row'>
                        <div className='col-md-3'>
                            <div className="card bg-primary text-white shadow  p-1">
                                <p>Waiting</p>
                                <span className="text-center"><h1>10</h1></span>
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <div className="card bg-info shadow p-1">
                                <p>Re Opened</p>
                                <span className="text-center"><h1>26</h1></span>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="card bg-warning shadow p-1">
                                <p>In Progress</p>
                                <span className="text-center"><h1>24</h1></span>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card bg-success text-white shadow p-1">
                                <p>Closed</p>
                                <span className="text-center"><h1>25</h1></span>
                            </div>
                        </div>
                    </div>
                    */}